import { Component, OnInit } from '@angular/core';
import { GameCreditBase } from 'app/common/gameCreditBase';
import { BetInfoService } from 'app/providers/bet-info/bet-info.service';

@Component({
  selector: 'app-ssc-credit-liangmianpan',
  templateUrl: './ssc-credit-liangmianpan.component.html',
  styleUrls: ['./ssc-credit-liangmianpan.component.css']
})
export class SscCreditLiangmianpanComponent extends GameCreditBase implements OnInit {

  public panel_arr: Array<any> = [
    [
      { name: '大', p: 0, val: null, is_select: false },
      { name: '小', p: 0, val: null, is_select: false },
      { name: '单', p: 0, val: null, is_select: false },
      { name: '双', p: 0, val: null, is_select: false }
    ],
    [
      { name: '大', p: 0, val: null, is_select: false },
      { name: '小', p: 0, val: null, is_select: false },
      { name: '单', p: 0, val: null, is_select: false },
      { name: '双', p: 0, val: null, is_select: false }
    ],
    [
      { name: '大', p: 0, val: null, is_select: false },
      { name: '小', p: 0, val: null, is_select: false },
      { name: '单', p: 0, val: null, is_select: false },
      { name: '双', p: 0, val: null, is_select: false }
    ],
    [
      { name: '大', p: 0, val: null, is_select: false },
      { name: '小', p: 0, val: null, is_select: false },
      { name: '单', p: 0, val: null, is_select: false },
      { name: '双', p: 0, val: null, is_select: false }
    ],
    [
      { name: '大', p: 0, val: null, is_select: false },
      { name: '小', p: 0, val: null, is_select: false },
      { name: '单', p: 0, val: null, is_select: false },
      { name: '双', p: 0, val: null, is_select: false }
    ],
    [
      { name: '总大', p: 0, val: null, is_select: false },
      { name: '总小', p: 0, val: null, is_select: false },
      { name: '总单', p: 0, val: null, is_select: false },
      { name: '总双', p: 0, val: null, is_select: false }
    ]
  ];


  constructor(
    public betInfoService: BetInfoService
  ) {
    super(betInfoService);
  }

  ngOnInit() {
    this.reset_balls_panel_handler();
  }

  /**
   * 重制号码状态
   *
   * @memberof SscCreditLiangmianpanComponent
   */
  public reset_balls_panel_handler() {
    this.panel_arr.forEach(item => {
      item.forEach(ball => {
        ball['is_select'] = false;
        ball['val'] = null;
      });
    });
  }

  /**
   * 填充奖金信息
   *
   * @memberof SscCreditLiangmianpanComponent
   */
  public fill_probilities_info_handler() {
    let p = this.prize_probability[0];

    this.panel_arr.forEach((item) => {
      item.forEach((ball) => {
        ball['p'] = (this.prize_group / 2000) * (1 / p);
      });
    });
  }

  /**
   * 切换球的状态
   *
   * @param {*} ball
   * @memberof SscCreditLiangmianpanComponent
   */
  public switch_ball_status_handler(ball: any) {
    ball.is_select = !ball.is_select;
    if (!ball.is_select) {
      ball.val = null;
    } else {
      ball.val = this.bet_value;
    }
  }

  /**
   * 设置输入框，选中球
   *
   * @param {*} ball
   * @memberof SscCreditLiangmianpanComponent
   */
  public selecte_ball_handler(ball: any) {
    ball.is_select = true;
    ball.val = this.bet_value;
  }

  /**
   * 渲染投注金额
   *
   * @memberof SscCreditLiangmianpanComponent
   */
  public render_bet_value_handler() {
    this.panel_arr.forEach((item) => {
      item.forEach(ball => {
        if (ball.is_select) {
          ball.val = this.bet_value;
        }
      });
    });
  }

}
